/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Legacy_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Timeline" |
*
* @param {Timeline_Legacy_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_legacy_aria_label = /** @type {((inputs?: Timeline_Legacy_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Legacy_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chronologie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitleiste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cronologia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Хронология")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cronología")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムライン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linha do tempo")
	return /** @type {LocalizedString} */ ("Timeline")
});